import { Vue, newVue } from '@/config/vue'

const init = () => {
  const NoticeMessage = Vue.component('notice-message', () =>
    import(/* webpackChunkName: "notice-message" */ './NoticeMessage.vue')
  )
  newVue({
    render: h => h(NoticeMessage),
    mount: '.js-vue-notice-message',
  })
}

On.VueInit({
  init({ isSpa }) {
    if (!isSpa) init()
  },
})
